import React, {
  createRef,
  useState,
  useEffect,
  Children,
  cloneElement,
} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import DropdownTrigger from './DropdownTrigger';
import DropdownLayover from './DropdownLayover';

import styles from './styles/index.module.scss';

const getChildType = (children, type) =>
  Children.toArray(children).find(
    child => child.type.displayName === type.displayName,
  );

const Dropdown = ({
  className,
  children,
  onMouseEnter,
  onMouseLeave,
  setIsVisible,
}) => {
  const [isLayoutVisible, setIsLayoutVisible] = useState(false);
  const [height, setHeight] = useState(0);
  const bodyRef = createRef();
  const trigger = getChildType(children, DropdownTrigger);
  const content = cloneElement(getChildType(children, DropdownLayover), {
    className,
    height,
  });
  const dropdownLayoverClassName = cn(styles.dropdownLayover, className);
  const handleMouseEnter = () => {
    setIsVisible(true);
    setIsLayoutVisible(true);
    onMouseEnter();
  };
  const handleMouseLeave = () => {
    setHeight(0);
    setIsVisible(false);
    setIsLayoutVisible(false);
    onMouseLeave();
  };
  useEffect(() => {
    if (isLayoutVisible) {
      setHeight(bodyRef?.current?.clientHeight || 0);
    }
  }, [isLayoutVisible]);
  return (
    <div
      className={styles.dropdownBody}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {trigger}
      <div
        className={dropdownLayoverClassName}
        style={{ height: `${height}px` }}
      >
        <div ref={bodyRef}>{isLayoutVisible && content}</div>
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  setIsVisible: PropTypes.func,
};

Dropdown.defaultProps = {
  className: undefined,
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  setIsVisible: () => {},
};

Dropdown.displayName = 'Dropdown';

export default Dropdown;
